module.exports = __webpack_public_path__ + "img/img_main_n_phone.d73cff69.png";